import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { trackBeginCheckout, trackPageView } from '@/lib/analytics';

/** Registra page views (e begin_checkout em /checkout) na vitrine. */
export function useAnalyticsTracker() {
  const location = useLocation();
  const lastPath = useRef<string>('');

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (path === lastPath.current) return;
    lastPath.current = path;

    trackPageView(path);
    if (location.pathname === '/checkout') {
      trackBeginCheckout();
    }
  }, [location.pathname, location.search]);
}
